import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { stylesSwitch } from './styles';
import ToggleBool from '../ToggleBool/index';
import { t } from '../../services/i18n';

function LabeledSwitch({
	children, label, value, onValueChange = () => { },
}) {
	return (
		<View style={stylesSwitch.container}>
			<TouchableOpacity onPress={() => onValueChange(!value)}>
				<View accessible>
					<Text style={stylesSwitch.label}>{`${children || label}:`}</Text>
				</View>
			</TouchableOpacity>
			<ToggleBool
				value={value}
				onPress={onValueChange}
				truthy={value ? t('Yes') : t('No')}
				radio
			/>
		</View>
	);
}

export default LabeledSwitch;
